import { Link } from "react-router-dom";

/**
 * CTA renders a call-to-action button driven by a CMS-editable config object.
 * config: { enabled, label, url, action }
 *   action = "enquiry" → triggers the enquiry modal (via onEnquire prop)
 *   action = "link"    → renders as a Link (internal /path) or <a> (http* URLs)
 * Returns null if disabled or missing config.
 */
export default function CTA({ config, onEnquire, variant = "primary", className = "", testId }) {
  if (!config || !config.enabled || !config.label) return null;

  const base = "inline-flex items-center px-8 py-4 text-xs uppercase tracking-[0.22em] font-medium transition-colors";
  const variantClass = {
    primary: "bg-ink text-ivory hover:bg-clay",
    ghost: "border border-ink/20 text-ink hover:bg-ink hover:text-ivory",
    onDarkPrimary: "bg-ivory text-ink hover:bg-clay hover:text-ivory",
    onDarkGhost: "border border-ivory/40 text-ivory hover:bg-ivory hover:text-ink",
  }[variant] || "";

  const cls = `${base} ${variantClass} ${className}`.trim();

  if (config.action === "enquiry" || !config.action) {
    return (
      <button type="button" onClick={onEnquire} className={cls} data-testid={testId}>
        {config.label}
      </button>
    );
  }
  // link action
  const url = config.url || "#";
  const isExternal = /^https?:\/\//i.test(url);
  if (isExternal) {
    return (
      <a href={url} target="_blank" rel="noreferrer" className={cls} data-testid={testId}>
        {config.label}
      </a>
    );
  }
  return (
    <Link to={url} className={cls} data-testid={testId}>
      {config.label}
    </Link>
  );
}
